import { gql } from 'apollo-boost'
import { ResetPlusSubscription, ResetPlusSubscriptionVariables } from './__generated__/ResetPlusSubscription'
import { useMutation } from '@apollo/react-hooks'

const RESET_PLUS_SUBSCRIPTION_MUTATION = gql`
  mutation ResetPlusSubscription($boardId: String!) {
    resetPlusSubscriptionV2(boardId: $boardId) {
      ... on PlusSubscriptionV2 {
        id
        subscriptionId
        paymentProvider
      }
      ... on PlusSubscriptionErrorV2 {
        error
        type
      }
    }
  }
`

export const useResetPlusSubscription = () => {
  return useMutation<ResetPlusSubscription, ResetPlusSubscriptionVariables>(RESET_PLUS_SUBSCRIPTION_MUTATION)
}
